export interface Payment {
  value: string;
  label: string;
}

interface Payments {
  debitoautomatico: Payment;
  fatura: Payment;
  cartaodecredito: Payment;
  [key: string]: Payment;
}
export const payments: Payments = {
  debitoautomatico: {
    value: 'Débito Automatico',
    label: 'Débito Automático',
  },
  fatura: {
    value: 'Fatura',
    label: 'Conta Digital',
  },
  cartaodecredito: {
    value: 'Cartão de Crédito',
    label: 'Cartão de Crédito',
  },
};
